import { EndPoints } from "@/Core/Client";
import instanceAxios from "@/Core/Client/AxiosConfig";
import {
    scheduledPostData,
    SchedulePostType,
} from "@/data/social-media-dashboard-data";
import { UserResponseDto } from "@/Dtos/user-dto";
import { useQuery } from "@tanstack/react-query";
import { IoNotifications, IoPerson, IoSettings } from "react-icons/io5";
import { PiCalendarBlankDuotone, PiClockDuotone } from "react-icons/pi";
import { useParams } from "react-router-dom";
import { Badge, Loader, Tab, Text } from "rizzui";
import SimpleBar from "simplebar-react";
import EmployeeInfo from "./components/employee-info";
import ProfileHeader from "./components/profile-header";
import { GetSocialOption } from "./utils";

export default function DetailsPage() {
    const { id } = useParams();

    // const [reload, setReload] = useState<boolean>(false);
    // const { data, isFetching } = useFetch<UserResponseDto>(
    //     {
    //         endPoint: EndPoints.user.crud,
    //         id: id,
    //         queryStrings: "",
    //         reload: reload,
    //     },
    //     {},
    // );
    const { isPending, data, isLoading, refetch } = useQuery<UserResponseDto>({
        queryKey: [id],
        queryFn: () =>
            instanceAxios
                .get<UserResponseDto>(`${EndPoints.user.crud}/80cd4d5ffbf04ce88765b50dd5f58a28`)
                .then((res) => res.data),
        // placeholderData: keepPreviousData,
    });

    if (isLoading || isPending)
        return (
            <div className="m-auto">
                <Loader variant="spinner" size="lg" />
            </div>
        );

    const tabList: {
        index: number;
        label: string;
        icon: React.ReactNode;
        panel: React.ReactNode;
    }[] = [
            {
                index: 0,
                label: "My Details",
                icon: <IoPerson className="h-5 w-5" />,
                // panel: <ActivityCard posts={scheduledPostData} />,
                panel: <EmployeeInfo employee={data!} />,
            },
            // {
            //     index: 1,
            //     label: "Documents",
            //     icon: <IoDocumentText className="size-5" />,
            //     panel: <DocumentPage employee={data} />,
            // },
            {
                index: 3,
                label: "Notifications",
                icon: <IoNotifications className="size-4" />,
                panel: (
                    <ActivityCard
                        posts={scheduledPostData.filter(
                            (i) => i.platform.toLowerCase() === "linkedin",
                        )}
                    />
                ),
            },
            {
                index: 4,
                label: "Settings",
                icon: <IoSettings className="size-4" />,
                panel: (
                    <ActivityCard
                        posts={scheduledPostData.filter(
                            (i) => i.platform.toLowerCase() === "linkedin",
                        )}
                    />
                ),
            },
        ];

    return (
        <>
            {/* <div className="@container"> */}
            {data && <ProfileHeader data={data} />}

            <Tab className="mt-4 bg-gray-0 dark:bg-gray-50">
                <Tab.List>
                    {tabList.map((tab) => (
                        <Tab.ListItem
                            key={tab.label}
                            className="justify-center"
                        >
                            {tab.icon && (
                                <span className="mr-1">{tab.icon}</span>
                            )}
                            {tab.label}
                        </Tab.ListItem>
                    ))}
                </Tab.List>
                <Tab.Panels>
                    {tabList.map((tab) => (
                        <Tab.Panel key={tab.label}>{tab.panel}</Tab.Panel>
                    ))}
                </Tab.Panels>
            </Tab>
            {/* </div> */}
        </>
    );
}

function ActivityCard({ posts }: { posts: SchedulePostType[] }) {
    return (
        <SimpleBar className="">
            {posts?.map((p, idx) => (
                <div key={idx} className="space-y-3 border-b border-muted py-4">
                    <GetSocialOption platform={p.platform} />
                    <Text>{p.title}</Text>
                    <div className="flex items-center justify-between">
                        <Badge rounded="md" variant="flat" color="info">
                            Schedule
                        </Badge>

                        <Text className="flex items-center gap-1 rounded-md border border-muted px-2 py-1">
                            <PiCalendarBlankDuotone className="size-4" />
                            {p.date}
                            <PiClockDuotone className="size-4" />
                            {p.time}
                        </Text>
                    </div>
                </div>
            ))}
        </SimpleBar>
    );
}